// extracted by mini-css-extract-plugin
module.exports = {"dashimg":"Document_dashimg__2ldKs","documentRow":"Document_documentRow__12Jqv","tabItem":"Document_tabItem__kSwHX"};